import { createSelector } from 'reselect'

import type { IEnrichedCockpitFinSobRow } from '../types'

import { selectCockpitCategoriesByOffering } from './selectCockpitCategoriesByOffering'
import { selectCockpitFinSobRows } from './selectCockpitFinSobRows'
import { selectCockpitOfferingsCatalog } from './selectCockpitOfferingsCatalog'
import { selectCockpitPartnerData } from './selectCockpitPartnerData'
import { selectCockpitSubCategoriesByCategory } from './selectCockpitSubCategoriesByCategory'

export const selectEnrichedCockpitFinSobRows = createSelector(
  [
    selectCockpitFinSobRows,
    selectCockpitPartnerData,
    selectCockpitOfferingsCatalog,
    selectCockpitCategoriesByOffering,
    selectCockpitSubCategoriesByCategory,
  ],
  (
    rows,
    partnerData,
    offeringsCatalog,
    categoriesByOffering,
    subCategoriesByCategory
  ): IEnrichedCockpitFinSobRow[] => {
    const offerings = new Map(
      offeringsCatalog.flatMap(({ offerings }) =>
        offerings.map((offering) => [offering.programType, offering] as const)
      )
    )
    const categories = new Map(
      Object.values(categoriesByOffering)
        .flat()
        .map((category) => [category.category, category] as const)
    )

    return rows.map((row) => {
      const offering = offerings.get(row.offering)
      const partner = partnerData.find((partner) => partner.PartnerId === row.partnerId)
      const category = categories.get(row.category)
      const subCategory = subCategoriesByCategory[row.category]?.find(
        (option) => option.subCategory === row.subCategory
      )

      return {
        ...row,
        offeringOrder: offering?.orderBy ?? -1,
        categoryOrder: category?.order ?? -1,
        subCategoryOrder: subCategory?.order ?? -1,
        countryCode: partner?.CountryCode ?? '',
      }
    })
  }
)
